import { useTranslation } from 'react-i18next'

import { CaretDoubleLeftIcon, SlidersHorizontalIcon } from '@phosphor-icons/react'

import { Button, ButtonGroup } from '@reveni-io/reveni-ui'

import PreviewModeChip from '../PreviewModeChip/PreviewModeChip'
import * as Styles from './styles'

const PreviewToolbar = ({
  viewMode,
  viewModeOptions,
  previewMode,
  onOpenPreviewSettings,
  showBlocksSidebar,
  onOpenBlocksSidebar,
}) => {
  const { t } = useTranslation()

  return (
    <Styles.Container data-testid="preview-toolbar">
      <Styles.PreviewSettings>
        <Button variant="text" size="s" onClick={onOpenPreviewSettings}>
          <SlidersHorizontalIcon size={20} />
          {t('Configuración de la preview')}
        </Button>
        <PreviewModeChip previewMode={previewMode} />
      </Styles.PreviewSettings>
      <ButtonGroup buttons={viewModeOptions} active={viewMode} />
      {!showBlocksSidebar && (
        <>
          <Styles.Separator />
          <Styles.ExpandBlocksSidebar>
            <Button variant="text" aria-label={t('Abrir menú de bloques')} onClick={onOpenBlocksSidebar}>
              <CaretDoubleLeftIcon size={20} />
            </Button>
          </Styles.ExpandBlocksSidebar>
        </>
      )}
    </Styles.Container>
  )
}

export default PreviewToolbar
